import { UiButtonComponent } from 'src/app/shared/ui';
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbCheckboxModule } from 'mdb-angular-ui-kit/checkbox';
import { AuthService, MdbToastService } from 'src/app/core/services';

@Component({
  selector: 'app-google-registration-dialog',
  templateUrl: './google-registration-dialog.component.html',
  styleUrls: ['./google-registration-dialog.component.scss'],
  standalone: true,
  imports: [UiButtonComponent, CommonModule, FormsModule, MdbFormsModule, MdbCheckboxModule],
})
export class GoogleRegistrationDialogComponent {
  username: string = '';
  acceptTOS: boolean = false;
  isSubmitting: boolean = false;
  errorMessage: string = '';

  constructor(
    public modalRef: MdbModalRef<GoogleRegistrationDialogComponent>,
    private authService: AuthService,
    private toast: MdbToastService
  ) {}

  get isFormValid(): boolean {
    return this.username.length >= 3 && this.acceptTOS;
  }

  async submit(): Promise<void> {
    if (!this.isFormValid || this.isSubmitting) return;

    this.isSubmitting = true;
    this.errorMessage = '';

    try {
      await this.authService.completeGoogleRegistration(
        this.username,
        this.acceptTOS,
        this.acceptTOS // acceptPrivacy - same checkbox
      );
      // Success - close modal with success flag
      this.modalRef.close({ success: true });
    } catch (e) {
      this.isSubmitting = false;
      // Show error message and keep modal open
      if (e.error === 'userExists') {
        this.errorMessage = 'Dieser Benutzername ist bereits vergeben.';
      } else if (e.error === 'emailExists') {
        this.errorMessage =
          'Ein Spieler mit dieser Email existiert bereits - nutze den normalen Passwort-Login!';
      } else if (e.error === 'googleAccountExists') {
        this.errorMessage =
          'Dieses Google-Konto ist bereits registriert - melde dich einfach mit Google an!';
      } else if (e.error === 'usernameForbidden') {
        this.errorMessage =
          'Der Benutzername verstößt gegen die Nutzungsbedingungen.';
      } else if (e.error === 'dontUseEmailAsUsername') {
        this.errorMessage =
          'Gib bitte nicht deine Email-Adresse als Benutzernamen an.';
      } else {
        this.errorMessage =
          'Registrierung fehlgeschlagen. Bitte versuche es erneut.';
      }
    }
  }

  cancel(): void {
    this.modalRef.close({ cancelled: true });
  }
}
